import React, { Fragment, useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useLocation } from "react-router";
import CommomForm from "../../../../Common/Components/Form";
import DropFile from "../../../../Common/Components/DropFile";
import CustomModal from "../../../../Common/Components/Modal/CustomModal";
import { useEditClass, useSingleData } from "../Hooks";
//class/update_details

function SingleClass() {
  const location = useLocation();

  const { data } = location.state;
  const { Data, loading, getData } = useSingleData();
  const { step, setstep, formSubmit, updateTeachers, deleteClass } =
    useEditClass(data.id);

  useEffect(() => {
    getData(data.slug);
  }, [step]);

  const renderSteps = () => {
    switch (step) {
      case 1:
        return (
          <div>
            <div className="d-flex align-items-center">
              <i className="fas fa-dumbbell" />
              <button
                className="btn"
                to="/User/ClassList/ClassInfoEdit"
                onClick={() => {
                  setstep(2);
                }}
              >
                ویرایش اطلاعات کلاس
              </button>
            </div>
            <div className="d-flex align-items-center">
              <i className="far fa-clock" />
              <button
                className="btn"
                onClick={() => {
                  setstep(3);
                }}
              >
                ویرایش زمانبندی
              </button>
            </div>
            <div className="d-flex align-items-center">
              <i className="fas fa-chalkboard-teacher" />
              <button
                className="btn"
                onClick={() => {
                  setstep(4);
                }}
              >
                ویرایش مدرسین
              </button>
            </div>
            <div className="d-flex align-items-center">
              <i className="fas fa-tag" />
              <button
                className="btn"
                onClick={() => {
                  setstep(5);
                }}
              >
                ویرایش تگ ها و تصاویر
              </button>
            </div>
            <div className="d-flex align-items-center">
              <i className="fas fa-trash" />
              <button
                className="btn"
                onClick={() => {
                  deleteClass();
                }}
              >
                حذف
              </button>
            </div>
          </div>
        );
      case 2:
        return (
          <EditInfo
            data={Data.Items}
            setstep={setstep}
            formSubmit={formSubmit}
          />
        );
      case 3:
        return (
          <EditTime
            data={Data.Items}
            setstep={setstep}
            formSubmit={formSubmit}
          />
        );
      case 4:
        return (
          <Teachers
            data={Data.Items}
            setstep={setstep}
            formSubmit={updateTeachers}
          />
        );
      case 5:
        return (
          <Tags data={Data.Items} setstep={setstep} formSubmit={formSubmit} />
        );
      default:
        return <h2>dwadw</h2>;
        break;
    }
  };
  return (
    <Fragment>
      {loading ? (
        ""
      ) : (
        <div className="card">
          <div className="card-body">{renderSteps()}</div>
        </div>
      )}
    </Fragment>
  );
}

export default SingleClass;
const EditInfo = ({ data, setstep, formSubmit }) => {
  const form = [
    {
      label: "نام",
      name: "name",
      type: "text",
      size: "col-md-4",
      value: data.name,
    },
    {
      label: "قیمت",
      name: "price",
      type: "text",
      size: "col-md-4",
      name: "price",
      value: data.price.price,
    },
    {
      label: "رده بندی سنی",
      input: "select",
      size: "col-md-4",
      name: "description",
      keyname: "agecatgegory",

      options: [
        {
          name: "کودکان",
          id: "child ",
        },
        {
          name: "نوجوانان",
          id: "teen",
        },
        {
          name: "جوانان",
          id: "young ",
        },
        {
          name: "بزرگسالان",
          id: "adults",
        },
      ],
    },
    {
      label: "توضیحات کلاس",
      name: "description",
      keyname: "text",
      type: "editor",
      size: "col-md-12",
      value: data.description.text,
    },

    {
      label: "جنسیت",
      name: "gender",
      input: "select",
      size: "col-md-6",
      // value: data.gender,
      options: [
        {
          name: "آقایان",
          id: "men",
        },
        {
          name: "بانوان",
          id: "women",
        },
        {
          name: "هردو",
          id: "both",
        },
      ],
    },
    {
      label: "نحوه برگزاری کلاس",
      name: "type",
      input: "select",
      size: "col-md-6",
      options: [
        {
          name: "حضوری",
          id: "offline",
        },
        {
          name: "مجازی",
          id: "online",
        },
        {
          name: "هردو",
          id: "both",
        },
      ],
    },
    {
      label:
        "آدرس ( در صورت حضوری آدرس محل برگذاری در صورت آنلاین بودن لینک کلاس )",
      name: "adress",
      type: "text",
      size: "col-md-12",
      value: data.adress,
    },
    {
      label: "ظرفیت",
      name: "capacity",
      type: "text",
      size: "col-md-6",
      value: data.capacity,
    },
    {
      label: "تعداد کل جلسات",
      name: "count_session",
      type: "text",
      size: "col-md-6",
      value: data.count_session,
    },
    {
      label: "آدرس  محل برگزاری",
      name: "address",
      type: "text",
      size: "col-md-6",
      keyname: "organizer_details",
      value: data.organizer_details.address,
    },
    {
      label: "لوکیشن محل برگزاری",
      name: "location",
      type: "text",
      size: "col-md-6",
      keyname: "organizer_details",

      value: data.organizer_details.location,
    },
    {
      label: "تلفن محل برگزاری",
      name: "phone",
      type: "text",
      size: "col-md-6",
      keyname: "organizer_details",
      value: data.organizer_details.phone,
    },
    {
      label: "موبایل  ",
      name: "mobile",
      type: "text",
      size: "col-md-6",
      keyname: "organizer_details",
      value: data.organizer_details.mobile,
    },
  ];
  return (
    <>
      <div className="d-flex justify-content-end">
        <button
          onClick={() => {
            setstep(1);
          }}
          className="btn"
        >
          بازگشت
        </button>
      </div>
      <CommomForm
        form={form}
        submit={formSubmit}
        // loading={loading}
        header="ویرایش اطلاعات کلاس"
        btnName="ثبت  "
      />
    </>
  );
};
const EditTime = ({ data, setstep, formSubmit }) => {
  const [form, setForm] = useState({
    details_session: data.details_session || [],
  });
  useEffect(() => {
    if (window.$(".clockpicker").length) {
      var inputs = window.$(".clockpicker");
      window.$.each(inputs, function (i, item) {
        window.$(item).clockpicker({
          donetext: "انجام شد",
          align: "right",
          autoclose: true,
        });
      });
    }
    setForm({ details_session: data.details_session || [] });
  }, []);
  const dayOfWeek = [
    {
      id: 0,
      name: "انتخاب کنید",
    },
    {
      id: "str",
      name: "شنبه",
    },
    {
      id: "sun",
      name: "یکشنبه",
    },
    {
      id: "mon",
      name: "دوشنبه",
    },
    {
      id: "thr",
      name: "سه شنبه",
    },
    {
      id: "wen",
      name: "چهارشنبه",
    },
    {
      id: "thu",
      name: "پنجشنبه",
    },
    {
      id: "frd",
      name: "جمعه",
    },
  ];
  const renderDay = id => {
    let result = "";
    dayOfWeek.map(day => {
      if (day.id == id) {
        result = day.name;
      }
    });
    return result;
  };
  return (
    <>
      <div className="d-flex justify-content-end">
        <button
          onClick={() => {
            setstep(1);
          }}
          className="btn"
        >
          بازگشت
        </button>
      </div>
      <div className="row mb-3">
        <div className="col-md-3">
          <select
            className="form-control"
            onChange={({ target: { value } }) => {
              setForm({ ...form, day: value });
            }}
          >
            {dayOfWeek.map((day, key) => {
              return (
                <option key={key} value={day.id}>
                  {day.name}
                </option>
              );
            })}
          </select>
        </div>
        <div className="col-md-3">
          <input
            id="clockpicker-1"
            placeholder="زمان شروع"
            type="text"
            autoComplete="off"
            className="clockpicker form-control"
            onClick={() => {
              if (window.$(".clockpicker").length) {
                var inputs = window.$(".clockpicker");
                window.$.each(inputs, function (i, item) {
                  window.$(item).clockpicker({
                    donetext: "انجام شد",
                    align: "right",
                    autoclose: true,
                  });
                });
              }
              window.$(`#clockpicker-1`).on("change", e => {
                let hours = window.$(e.target).clockpicker().data()
                  .clockpicker.hours;
                let minutes = window.$(e.target).clockpicker().data()
                  .clockpicker.minutes;
                window.$(e.target).attr("data-hours", hours);
                window.$(e.target).attr("data-minutes", minutes);
                if (minutes < 10) {
                  minutes = "0" + minutes.toString();
                }
                if (hours < 10) {
                  hours = "0" + hours.toString();
                }

                setForm({
                  ...form,
                  start: `${hours}:${minutes}`,
                });
              });
            }}
          />
        </div>{" "}
        <div className="col-md-3">
          <input
            id="clockpicker-2"
            placeholder="زمان پایان"
            type="text"
            className="clockpicker form-control"
            autoComplete="off"
            onClick={() => {
              if (window.$(".clockpicker").length) {
                var inputs = window.$(".clockpicker");
                window.$.each(inputs, function (i, item) {
                  window.$(item).clockpicker({
                    donetext: "انجام شد",
                    align: "right",
                    autoclose: true,
                  });
                });
              }
              window.$(`#clockpicker-2`).on("change", e => {
                let hours = window.$(e.target).clockpicker().data()
                  .clockpicker.hours;
                let minutes = window.$(e.target).clockpicker().data()
                  .clockpicker.minutes;
                window.$(e.target).attr("data-hours", hours);
                window.$(e.target).attr("data-minutes", minutes);
                if (minutes < 10) {
                  minutes = "0" + minutes.toString();
                }
                if (hours < 10) {
                  hours = "0" + hours.toString();
                }

                setForm({
                  ...form,
                  end: `${hours}:${minutes}`,
                });
              });
            }}
          />
        </div>
        <div>
          <button
            className="btn btn-warning text-white"
            onClick={() => {
              let newList = [];
              // newList.push(state);
              setForm({
                ...form,
                details_session: [
                  ...form.details_session,
                  { day: form.day, start: form.start, end: form.end },
                ],
              });
            }}
          >
            اضافه کردن
          </button>
        </div>
      </div>
      <div className="row">
        {form &&
          form.details_session &&
          form.details_session.map((day, key) => {
            return (
              <div className="col-md-2" key={key}>
                <div className="card">
                  <div className="card-body">
                    <h3 className="card-title">{renderDay(day.day)}</h3>
                    <h6>{`${day.start} - ${day.end}`}</h6>
                    <button
                      className="btn bg-primary"
                      onClick={() => {
                        setForm({
                          details_session: [...form.details_session].filter(
                            item =>
                              !(
                                item.day == day.day &&
                                item.start == day.start &&
                                item.end == day.end
                              )
                          ),
                        });
                      }}
                    >
                      حذف
                    </button>
                  </div>
                </div>
              </div>
            );
          })}
      </div>
      <div className="row">
        <div className="col">
          <button
            onClick={() => {
              formSubmit(form);
            }}
            className="btn btn-primary"
          >
            ثبت تغییرات
          </button>
        </div>
      </div>
    </>
  );
};
const Teachers = ({ data, setstep, formSubmit }) => {
  const [state, setstate] = useState({});
  const { Data, getData } = useSingleData();
  const [form, setForm] = useState({ teachers: [] });
  useEffect(() => {
    setForm({ teachers: data.teachers });
    getData();
  }, []);
  const filterData = id => {
    setForm({
      teachers: [...form.teachers].filter((card, count) => count != id),
    });
    toast.success("مدرس با موفقیت حذف شد");
  };
  const checkEmpty = data => {
    if (data) {
      if (data.length == 0) {
        return false;
      } else {
        return true;
      }
    } else {
      return false;
    }
  };
  const [modal, setModal] = useState(false);
  const forms = [
    { key: "name", name: "نام", type: "input" },
    { key: "cv", name: "رزرومه" },
    { key: "proof", name: "مدارک" },
    { key: "activity", name: "سابقه فعالیت" },
    { key: "details", name: "جزییات" },
    { key: "image", name: "image", type: "img" },
  ];

  return (
    <Fragment>
      <div className="d-flex justify-content-end">
        <button
          onClick={() => {
            setstep(1);
          }}
          className="btn"
        >
          بازگشت
        </button>
      </div>
      <div className="row">
        <CustomModal show={modal} handleClose={() => setModal(false)}>
          <div className="row">
            {forms &&
              forms.map((form, key) => {
                if (form.type == "img") {
                  return (
                    <Fragment key={key}>
                      <DropFile
                        key={key}
                        // value={form[element.key]}
                        accept={"image/png, image/jpeg"}
                        set={e => {
                          setstate({ ...state, image: e });
                        }}
                      />
                    </Fragment>
                  );
                }
                if (form.type == "input") {
                  return (
                    <div className="col-md-4" key={key}>
                      <div className="form-group">
                        <label>{form.name}</label>
                        <input
                          className="form-control"
                          onChange={e => {
                            setstate({
                              ...state,
                              [form.key]: e.target.value,
                            });
                          }}
                        />
                      </div>
                    </div>
                  );
                }
                return (
                  <div className="col-md-4" key={key}>
                    <div className="form-group">
                      <label>{form.name}</label>
                      <textarea
                        className="form-control"
                        onChange={e => {
                          setstate({
                            ...state,
                            [form.key]: e.target.value,
                          });
                        }}
                      />
                    </div>
                  </div>
                );
              })}
            <div className="col">
              <button
                className="btn btn-danger"
                onClick={() => {
                  formSubmit({
                    action: "add",
                    ...state,
                  });
                }}
              >
                ثبت
              </button>
            </div>
          </div>
        </CustomModal>
      </div>
      <div className="row mt-3">
        {!checkEmpty(form.teachers) && (
          <div className="col-12">
            <h6 className="text-center">مدرسی ثبت نشده است</h6>
          </div>
        )}
        {form.teachers &&
          form.teachers.map((card, count) => {
            return (
              <div className="col-md-3" key={count}>
                <div className="card">
                  <img
                    className="card-img-top"
                    src={card.image && card.image[0] && card.image[0]}
                    alt={card.name}
                    style={{
                      width: "200px",
                      height: "100px",
                      objectFit: "contain",
                    }}
                  />
                  <div className="card-body">
                    <h5 className="card-title">{card.name}</h5>
                    <div className="d-flex flex-column">
                      <h6>رزرومه</h6>
                      <p style={{ fontSize: "12px" }}>{card.cv}</p>
                    </div>
                    <div className="d-flex flex-column">
                      <h6>مدارک</h6>
                      <p style={{ fontSize: "12px" }}>{card.proof}</p>
                    </div>
                    <div className="d-flex flex-column">
                      <h6>سابقه فعالیت</h6>
                      <p style={{ fontSize: "12px" }}>{card.activity}</p>
                    </div>
                    <div className="d-flex flex-column">
                      <h6>جزییات</h6>
                      <p style={{ fontSize: "12px" }}>{card.details}</p>
                    </div>
                    <button
                      onClick={() => {
                        formSubmit({
                          action: "delete",
                          teacher_id: card.id,
                        });
                      }}
                      disabled={form.teachers.length == 1}
                      href="#"
                      className="btn btn-primary text-white btn-block"
                    >
                      حذف
                    </button>
                  </div>
                </div>
              </div>
            );
          })}
      </div>
      <div className="row">
        <div className="col">
          <div className="d-flex justify-content-center">
            <button onClick={() => setModal(true)} className="btn btn-primary">
              <span>ثبت مدرس جدید</span>
              <i className="fas fa-plus"></i>
            </button>
          </div>
        </div>
      </div>
    </Fragment>
  );
};
const Tags = ({ data, setstep }) => {
  const initialState = {
    loading: false,
  };
  const [state, setstate] = useState(initialState);
  const getTagsId = tags => {
    if (tags) {
      return tags.map(tag => tag.tag_id.toString());
    }
  };
  const { formSubmit, loading, getTag, Data } = useEditClass(data.id);

  let input = [
    {
      label: "تگ های مجموعه",
      size: "col-md-3",
      classNames: "mt-2 js-select2",
      placeholder: "",
      name: "tags",
      input: "select",
      multiple: true,
      selected: getTagsId(data.tags),
      value: getTagsId(data.tags),
    },

    {
      label: "تصاویر مجموعه",
      size: "col-md-12",
      classNames: "mt-2",
      placeholder: "",
      name: "images",
      input: "file",
      accept: "image/png, image/jpeg",
    },
    {
      label: "کلمات کلیدی سئو",
      size: "col-md-12",
      classNames: "mt-2",
      placeholder: "",
      name: "seo",
      keyname: "seoKeyword",
      value: data.seo.seoKeyword,
      input: "textarea",
    },
    {
      label: "توضیحات کلیدی سئو",
      size: "col-md-12",
      classNames: "mt-2",
      placeholder: "",
      name: "seo",
      keyname: "seoDescription",
      value: data.seo.seoDescription,
      input: "textarea",
    },
  ];

  return (
    <div>
      <div className="d-flex justify-content-end">
        <button
          onClick={() => {
            setstep(1);
          }}
          className="btn"
        >
          بازگشت
        </button>
      </div>
      <CommomForm
        form={input}
        loading={loading}
        btnName="ثبت ویرایش"
        methods={{}}
        submit={formSubmit}
      ></CommomForm>
    </div>
  );
};
